export default __webpack_public_path__ + "static/media/15.b2896fc2.webp";